import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { ClawbackReceiverDelegation } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Clawback';
import { TransferOffer } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Transfer';
import {
  RegistrarService,
  RegistrarService_Clawback,
} from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Registrar';
import { Holding } from '@daml.js/dtc-registry-holding/lib/Dtc/Registry/Holding/V3/Holding';
import { InstrumentConfiguration } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Configuration/Instrument';
import { DvpLegAllocation } from '@daml.js/dtc-registry/lib/Dtc/Registry/V3/Holding/Allocation';
import { ExtraArgs } from '@daml.js/splice-api-token-metadata/lib/Splice/Api/Token/MetadataV1';
import { ContractId } from '@daml/types';
import { ERR_CLAWBACK, SUC_CLAWBACK } from '../../../utils/strings';

interface Args {
  registrarServiceCid: ContractId<RegistrarService>;
  instrumentConfigurationCid: ContractId<InstrumentConfiguration>;
  inputHoldingCids: string[];
  owner: string;
  receiverDelegation?: { party: string; cid: ContractId<ClawbackReceiverDelegation> };
  clawbackAmount: string;
  transferOfferCids?: string[];
  allocationCids?: string[];
  extraArgs?: ExtraArgs;
}

export const useClawback = () => {
  const { submit: clawback } = useExerciseSubmission(
    RegistrarService.RegistrarService_Clawback,
    SUC_CLAWBACK,
    ERR_CLAWBACK,
  );

  const doClawback = async (args: Args) => {
    const {
      instrumentConfigurationCid,
      registrarServiceCid,
      inputHoldingCids,
      owner,
      receiverDelegation,
      clawbackAmount,
      transferOfferCids,
      allocationCids,
      extraArgs,
    } = args;

    const payload: RegistrarService_Clawback = {
      instrumentConfigurationCid,
      inputHoldingCids: inputHoldingCids.map((cid) => cid as ContractId<Holding>),
      owner,
      receiverDelegation: receiverDelegation
        ? { _1: receiverDelegation.party, _2: receiverDelegation.cid }
        : null,
      clawbackAmount,
      transferOfferCids: transferOfferCids?.length
        ? transferOfferCids.map((cid) => cid as ContractId<TransferOffer>)
        : null,
      allocationCids: allocationCids?.length
        ? allocationCids.map((cid) => cid as ContractId<DvpLegAllocation>)
        : null,
      extraArgs: extraArgs ?? null,
      allocationV2Cids: null,
    };

    await clawback({
      cid: registrarServiceCid,
      argument: payload,
    });
  };

  return doClawback;
};
